import Tabs from "apps/website/components/feature/Tabs/Tabs";
import Section from "apps/website/components/layout/Section/Section";
import Container from "apps/website/components/layout/Container/Container";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";

import {
  recipeComparisonKatkinData,
} from "./shared/recipeComparisonKatkinData";
import { SUBTITLE, TITLE } from "./constants";

export default function SectionRecipeComparison() {
  return (
    <Section component="SectionRecipeComparison" className="pb-8 xl:pb-0">
      <Container padding="none">
        <div className="mx-12">
          <TextTitle size={1} align="center" className="mb-4">
            { TITLE }
          </TextTitle>
          <TextSubtitle size={1} align="center" className="mb-4">
            { SUBTITLE }
          </TextSubtitle>
        </div>
        <Tabs tabs={recipeComparisonKatkinData.tabs} defaultActiveTab={recipeComparisonKatkinData.defaultActiveTab} />
      </Container>
    </Section>
  );
}
